/**
 * Define partition name here. Similar with
 * https://github.sc-corp.net/Snapchat/android/blob/master/snapchat/platform/analytics/graphene/api/src/main/java/com/snap/graphene/schema/Partition.java
 */
export enum Partition {
  UNDEFINED = 'undefined',
  ADS_LIBRARY = 'ads_library',
  ADS_MANAGER = 'ads_manager',
  BUSINESS_MANAGER = 'business_manager',
  PROFILE_MANAGER = 'profile_manager',
  REVIEW_TOOL = 'review_tool',
  SNAP_MAPS = 'snap_maps',
  FOR_BUSINESS = 'for_business',
  ADFORMATS_WEB = 'adformats_web',
  DISCOVER_CMS = 'discover_cms',
  SNAP_WEB = 'snap_web',
  NEWSROOM = 'newsroom',
  YELLOW_LA = 'yellow_la',
  CITIZEN_SNAP = 'citizen_snap',
  SNAP_FOUNDATION = 'snap_foundation',
  ENG_BLOG = 'eng_blog',
  RESEARCH_SNAP = 'research_snap',
  MY_LENSES = 'my_lenses',
  PLAYCANVAS = 'playcanvas',
  MEASUREMENT_PORTAL = 'measurement_portal',
  TRUST = 'trust',
  CHEERIOS = 'cheerios',
  SPS = 'sps',
  // added partitions by Bynd team
  AR_SNAP = 'ar_snap',
  DEVELOPER_SNAP = 'developer_snap',
  DANDELION = 'dandelion',
  CREATORS_SNAP = 'creators_snap',
  DIVERSITY = 'diversity',
  // to be used for snapchat on the web, including web sharing and story.snapchat.com
  SNAPCHAT_WEB = 'snapchat_web',
  EMBEDDED_WEBVIEW_ADS = 'embedded_webview_ads',
  METRICS_MONITOR = 'metrics_monitor',
  SNAPGRAPH = 'snapgraph',
  MEASUREMENT_RESONANCE_SURVEY = 'measurement_resonance_survey',
  MEASUREMENT_MR_SURVEY = 'measurement_mr_survey',
  MEASUREMENT_COLLECTION_SURVEY = 'measurement_collection_survey',
  // used for story studio lite (my.snapchat.com) - https://snapchat.quip.com/LRWmAVmV90zp
  STORY_STUDIO_LITE = 'story_studio_lite',
  // used for metrics within the web_self_serve_ads monorepo https://github.sc-corp.net/Snapchat/web-self-serve-ads
  WEB_SELF_SERVE_ADS = 'web_self_serve_ads',
  ARCADIA = 'arcadia',
  SNAP_523 = 'snap_523',
  ORIGINALS = 'originals',
  // used for the law enforcement operations (LEO) internal web tool repo: https://github.sc-corp.net/Snapchat/leo-portal
  LEO_WEB = 'leo_web',
  // used for desktop web snapchat client
  DWEB = 'dweb',
  SCN_CONTENT_MANAGER = 'scn_content_manager',
  ADVERTISER_360 = 'advertiser_360',
  CAREERS = 'careers',
  PRIVACY_INFRA = 'privacy_infra',
  BLIZZARD = 'blizzard',
  // used for the Snap cookie modal and related settings page used across website properties
  COOKIE_MODAL_COMPONENTS = 'cookie_modal_components',
  // used for content tools projects (storyteller, BIB) https://github.sc-corp.net/Snapchat/search/tree/master/ranking/snapgraph/web
  CONTENT_TOOLS = 'content_tools',
  WEB_ACCOUNTS = 'web_accounts',
  // used for metrics within the marketing-web monorepo - https://github.sc-corp.net/Snapchat/marketing-web
  MARKETING_WEB_PLATFORM = 'marketing_web_platform',
  // added by AR Enterprise Shopping for off-platform web experiences through our SDK
  ARES_SDK = 'ares_sdk',
  // used for metrics on SnapOrca - https://github.sc-corp.net/Snapchat/snap-orca/
  SNAP_ORCA = 'snap_orca',
  // used for metrics on Safety Review Tool - https://github.sc-corp.net/Snapchat/safety-review-tool
  SAFETY_REVIEW_TOOL = 'safety_review_tool',
  // used for adding metrics to the Reporting-Service SDK
  REPORTING_SERVICE = 'reporting_service',
  // used for calling
  SCN_ADDLIVE = 'scn_addlive',
  // Used for Quality Org tooling
  QUALITY = 'quality',
  // used by parents.snapchat.com MWP microsite
  PARENTS = 'parents',
  // used by enterprise manager
  ENTERPRISE_MANAGER = 'enterprise_manager',
  // used by digital asset manager
  DIGITAL_ASSET_MANAGER = 'digital_asset_manager',
  // used by lens web builder - https://github.sc-corp.net/Snapchat/Lens-web-builder
  LENS_WEB_BUILDER = 'lens_web_builder',
  // used by Snapchat Camera for web (browser extension)
  SNAPCHAT_CAMERA_BROWSER_EXTENSION = 'snapchat_camera_browser_extension',
  // used by web ar player https://github.sc-corp.net/Snapchat/web-ar-player
  WEB_AR_PLAYER = 'web_ar_player',
  // Used by any web product that is using standard logging without a need for a special partition.
  // https://wiki.sc-corp.net/pages/viewpage.action?pageId=292521031
  WEB_COMMON = 'web_common',
  // used for metrics in hosted lenses - https://github.sc-corp.net/Snapchat/hosted-lenses-ui
  HOSTED_LENSES = 'hosted_lenses',
  AVALON = 'avalon',
  // our in-house attestation solution - currently https://github.sc-corp.net/Snapchat/kameleon
  ATTESTATION = 'attestation',
  EXPERIENCE = 'experience',
  // used by lens services team for work on the ar.snap.com/download page
  AR_WEB = 'ar_web',
  // used by LEO's Law Enforcement Operations Portal (LESS) - https://github.sc-corp.net/Snapchat/less
  SNAP_LESS = 'snap-less',
  // used by the data protection team
  SNAP_IAM_WEB = 'snap_iam_web',
  // My AI Enterprise
  MY_AI_ENTERPRISE = 'my_ai_enterprise',
}
